/* =====================================================================
   My Clean Supplies — slide-out cart drawer (self-contained, no deps).
   - Intercepts product add-to-cart forms -> AJAX /cart/add.js -> opens drawer
   - Opens on header cart icon click
   - Qty change / remove via /cart/change.js
   - No discount bar. Payment icons under checkout button (in markup).
   ===================================================================== */
(function () {
  "use strict";

  var CFG = window.MCS_CART || {};
  var MONEY_FORMAT = CFG.moneyFormat || "${{amount}}";
  var ADD_URL = CFG.addUrl || "/cart/add.js";
  var CHANGE_URL = CFG.changeUrl || "/cart/change.js";
  var CART_URL = CFG.cartUrl || "/cart";

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---- money ---- */
  function formatMoney(cents) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    var value = "";
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    function defaultTo(num, precision, thousands, decimal) {
      thousands = thousands || ",";
      decimal = decimal || ".";
      if (isNaN(num) || num == null) return 0;
      num = (num / 100).toFixed(precision);
      var parts = num.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : "";
      return dollars + centsPart;
    }
    var match = MONEY_FORMAT.match(placeholderRegex);
    var fmt = match ? match[1] : "amount";
    switch (fmt) {
      case "amount": value = defaultTo(cents, 2); break;
      case "amount_no_decimals": value = defaultTo(cents, 0); break;
      case "amount_with_comma_separator": value = defaultTo(cents, 2, ".", ","); break;
      case "amount_no_decimals_with_comma_separator": value = defaultTo(cents, 0, ".", ","); break;
      case "amount_with_space_separator": value = defaultTo(cents, 2, " ", ","); break;
      default: value = defaultTo(cents, 2);
    }
    return MONEY_FORMAT.replace(placeholderRegex, value);
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function sizedImage(url, w) {
    if (!url) return "";
    if (url.indexOf("?") > -1) return url + "&width=" + w;
    return url + "?width=" + w;
  }

  function linePriceHtml(originalLine, finalLine) {
    return (originalLine > finalLine)
      ? '<s class="mcs-cd-item__was">' + formatMoney(originalLine) + '</s> <span class="mcs-cd-item__now">' + formatMoney(finalLine) + '</span>'
      : formatMoney(finalLine);
  }

  /* ---- drawer open/close ---- */
  var drawer;
  // Live cart totals (cents), kept in sync by render() so a qty click can update
  // the line price + subtotal optimistically without waiting for the server.
  var cartTotalCents = 0, cartSavingsCents = 0;
  function openDrawer() {
    if (!drawer) return;
    drawer.classList.add("is-open");
    drawer.setAttribute("aria-hidden", "false");
    document.documentElement.classList.add("mcs-cd-lock");
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove("is-open");
    drawer.setAttribute("aria-hidden", "true");
    document.documentElement.classList.remove("mcs-cd-lock");
  }

  /* ---- header count ---- */
  function updateHeaderCount(count) {
    // Empire renders the number from the data attribute via CSS (content: attr(...)).
    // Do NOT also set textContent or the count shows twice.
    $all(".site-header-cart--count").forEach(function (el) {
      el.setAttribute("data-header-cart-count", count > 0 ? count : "");
      el.classList.toggle("visible", count > 0);
    });
  }

  /* ---- render ---- */
  function render(cart) { renderBase(cart); guardGifts(cart); }
  function renderBase(cart) {
    var body = $("[data-mcs-cd-body]", drawer);
    var empty = $("[data-mcs-cd-empty]", drawer);
    var foot = $("[data-mcs-cd-foot]", drawer);
    var countEl = $("[data-mcs-cd-count]", drawer);
    if (countEl) countEl.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";
    updateHeaderCount(cart.item_count);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = "";
      if (empty) empty.hidden = false;
      if (foot) foot.hidden = true;
      return;
    }
    if (empty) empty.hidden = true;
    if (foot) foot.hidden = false;

    var ordered = cart.items.filter(function (it) { return !isGiftLine(it); }).concat(cart.items.filter(isGiftLine));
    body.innerHTML = ordered.map(function (item, i) {
      var line = i + 1;
      var variant = (item.variant_title && item.variant_title !== "Default Title") ? item.variant_title : "";
      var img = item.image ? '<img class="mcs-cd-item__img" src="' + esc(sizedImage(item.image, 160)) + '" alt="' + esc(item.product_title) + '" width="64" height="64" loading="lazy">' : '<div class="mcs-cd-item__img mcs-cd-item__img--ph"></div>';
      var priceHtml = linePriceHtml(item.original_line_price, item.final_line_price);
      var title = esc(item.product_title);
      if (isGiftLine(item)) return giftLineHtml(item, line, img);
      return '' +
        '<div class="mcs-cd-item" data-line="' + line + '" data-key="' + esc(item.key) + '" data-unit-final="' + item.final_price + '" data-unit-orig="' + item.original_price + '">' +
          '<a class="mcs-cd-item__media" href="' + esc(item.url) + '">' + img + '</a>' +
          '<div class="mcs-cd-item__info">' +
            '<a class="mcs-cd-item__title" href="' + esc(item.url) + '">' + esc(item.product_title) + '</a>' +
            (variant ? '<div class="mcs-cd-item__variant">' + esc(variant) + '</div>' : '') +
            ((item.properties && item.properties["Free gift"]) ? '<div class="mcs-cd-item__gift"><svg viewBox="0 0 16 16" aria-hidden="true"><path d="M2 7.5h12V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7.5Z" fill="currentColor" opacity=".85"/><path d="M1.25 4.5h13.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-.75.75H1.25a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 0 1 .75-.75Z" fill="currentColor"/><path d="M8 4.5S6.6 1 5.1 1a1.6 1.6 0 0 0 0 3.5H8Zm0 0S9.4 1 10.9 1a1.6 1.6 0 0 1 0 3.5H8Z" fill="currentColor"/></svg><span>Free gift: ' + esc(item.properties["Free gift"]) + '</span></div>' : '') +
            '<div class="mcs-cd-item__row">' +
              '<div class="mcs-cd-qty" role="group" aria-label="Quantity">' +
                '<button type="button" class="mcs-cd-qty__btn" data-mcs-qty-dn aria-label="Decrease quantity of ' + title + '">&minus;</button>' +
                '<span class="mcs-cd-qty__n">' + item.quantity + '</span>' +
                '<button type="button" class="mcs-cd-qty__btn" data-mcs-qty-up aria-label="Increase quantity of ' + title + '">&plus;</button>' +
              '</div>' +
              '<span class="mcs-cd-item__price">' + priceHtml + '</span>' +
            '</div>' +
          '</div>' +
          '<button type="button" class="mcs-cd-item__remove" data-mcs-remove aria-label="Remove ' + title + '">&times;</button>' +
        '</div>';
    }).join("");

    cartTotalCents = cart.total_price;
    cartSavingsCents = cart.total_discount || ((cart.original_total_price || cart.total_price) - cart.total_price);

    var sub = $("[data-mcs-cd-subtotal]", drawer);
    if (sub) sub.textContent = formatMoney(cartTotalCents);

    var savingsRow = $("[data-mcs-cd-savings]", drawer);
    var savingsAmt = $("[data-mcs-cd-savings-amount]", drawer);
    var savings = cartSavingsCents;
    if (savingsRow) {
      if (savings > 0) {
        savingsRow.hidden = false;
        if (savingsAmt) savingsAmt.textContent = "-" + formatMoney(savings);
      } else {
        savingsRow.hidden = true;
      }
    }
  }

  // Update this line's price + the subtotal/savings instantly on a qty click,
  // before the server round-trip. final_price/original_price are per-unit
  // (cents); MCS automatic discounts are percentage, so they scale linearly.
  // render() reconciles everything against the server response when it lands.
  function optimisticQty(itemEl, oldQty, newQty) {
    var unitFinal = parseInt(itemEl.getAttribute("data-unit-final"), 10);
    if (isNaN(unitFinal)) return; // no unit data -> just let render() handle it
    var unitOrig = parseInt(itemEl.getAttribute("data-unit-orig"), 10);
    if (isNaN(unitOrig)) unitOrig = unitFinal;
    var dq = newQty - oldQty;

    if (newQty <= 0) {
      itemEl.style.display = "none"; // being removed; hide now instead of flashing $0.00
    } else {
      var priceEl = itemEl.querySelector(".mcs-cd-item__price");
      if (priceEl) priceEl.innerHTML = linePriceHtml(unitOrig * newQty, unitFinal * newQty);
    }

    cartTotalCents += dq * unitFinal;
    cartSavingsCents += dq * (unitOrig - unitFinal);

    var sub = $("[data-mcs-cd-subtotal]", drawer);
    if (sub) sub.textContent = formatMoney(cartTotalCents);

    var savingsRow = $("[data-mcs-cd-savings]", drawer);
    var savingsAmt = $("[data-mcs-cd-savings-amount]", drawer);
    if (savingsRow) {
      if (cartSavingsCents > 0) {
        savingsRow.hidden = false;
        if (savingsAmt) savingsAmt.textContent = "-" + formatMoney(cartSavingsCents);
      } else {
        savingsRow.hidden = true;
      }
    }
  }

  /* ---- network ---- */
  function getCart() {
    // no-store: never let the browser/bfcache hand back a stale cart snapshot.
    return fetch(CART_URL + ".js", { cache: "no-store", headers: { Accept: "application/json" } }).then(function (r) { return r.json(); });
  }
  // Change by line-item KEY (stable id), not by positional line index. The
  // positional index shifts the moment any item is removed, so a queued change
  // would otherwise hit the wrong product.
  function changeByKey(key, qty) {
    return fetch(CHANGE_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function (r) { return r.json(); });
  }
  function refresh() { return getCart().then(render); }

  // Serialize every cart mutation. Overlapping /cart/change.js requests (e.g.
  // remove one item while bumping another, or rapid +/-) race on the server and
  // silently drop updates — a removed item "comes back", increments vanish.
  // Chaining them guarantees each runs against the committed result of the last.
  var cartQueue = Promise.resolve();
  function enqueue(task) {
    cartQueue = cartQueue.then(task).catch(function () { return refresh(); });
    return cartQueue;
  }

  /* ---- free gifts (2026-10-15, Prestige Truck model) ----
     A gift is a hidden $0 "twin" product (type "Free Gift"). It is added right after its machine with the
     properties "Free gift with" (shown on the order) and _gift_for (the machine's variant id). The guard removes
     any gift whose machine is no longer in the cart, keeps each gift at qty 1, and drops a twin added on its own. */
  function isGiftLine(it) {
    return !!((it.properties && it.properties["_gift_for"]) || it.product_type === "Free Gift");
  }
  function giftLineHtml(item, line, img) {
    var cents = Math.round(parseFloat((item.properties && item.properties["_gift_value"]) || "0") * 100);
    var name = String(item.product_title || "").replace(/^Free Gift:\s*/i, "");
    var withTitle = (item.properties && item.properties["Free gift with"]) || "your order";
    return '' +
      '<div class="mcs-cd-item mcs-cd-item--gift" data-line="' + line + '" data-key="' + esc(item.key) + '" data-unit-final="0" data-unit-orig="0">' +
        '<span class="mcs-cd-item__media">' + img + '</span>' +
        '<div class="mcs-cd-item__info">' +
          '<span class="mcs-cd-item__title">' + esc(name) + '</span>' +
          '<div class="mcs-cd-item__giftfor">Free gift with ' + esc(withTitle) + '</div>' +
          '<div class="mcs-cd-item__row"><span></span><span class="mcs-cd-item__free">FREE' + (cents > 0 ? '<s>' + formatMoney(cents) + '</s>' : '') + '</span></div>' +
        '</div>' +
        '<button type="button" class="mcs-cd-item__remove" data-mcs-remove aria-label="Remove free gift ' + esc(name) + '">&times;</button>' +
      '</div>';
  }
  var guarding = false;
  function guardGifts(cart) {
    if (guarding || !cart || !cart.items || !cart.items.length) return;
    var paid = {};
    cart.items.forEach(function (it) { if (!isGiftLine(it)) paid[String(it.variant_id)] = true; });
    var fixes = [];
    cart.items.forEach(function (it) {
      if (!isGiftLine(it)) return;
      var parent = it.properties && it.properties["_gift_for"];
      if (!parent || !paid[String(parent)]) fixes.push([it.key, 0]);
      else if (it.quantity > 1) fixes.push([it.key, 1]);
    });
    if (!fixes.length) return;
    guarding = true;
    enqueue(function () {
      return fixes.reduce(function (p, f) { return p.then(function () { return changeByKey(f[0], f[1]); }); }, Promise.resolve())
        .then(function () { guarding = false; return refresh(); }, function () { guarding = false; });
    });
  }
  function addGifts(fd) {
    var box = document.querySelector("[data-mcs-gifts]");
    var mainId = fd && fd.get ? String(fd.get("id") || "") : "";
    if (!box || !mainId) return Promise.resolve();
    var picks = Array.prototype.slice.call(box.querySelectorAll("input[data-mcs-gift]:checked"));
    if (!picks.length) return Promise.resolve();
    var forTitle = box.getAttribute("data-product-title") || "";
    return getCart().then(function (cart) {
      var have = {};
      (cart.items || []).forEach(function (it) { have[String(it.variant_id)] = true; });
      var items = picks.filter(function (p) { return !have[p.getAttribute("data-mcs-gift")]; }).map(function (p) {
        return { id: Number(p.getAttribute("data-mcs-gift")), quantity: 1,
          properties: { "Free gift with": forTitle, "_gift_for": mainId, "_gift_value": p.getAttribute("data-value-money") || "" } };
      });
      if (!items.length) return;
      return fetch(ADD_URL, { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) });
    });
  }

  /* ---- add to cart ---- */
  var adding = false;
  function handleAdd(form) {
    if (adding) return;
    adding = true;
    var btn = form.querySelector("[data-product-atc], [name='add'], [type='submit']");
    if (btn) btn.classList.add("is-loading");
    var fd = new FormData(form);
    function done() { adding = false; if (btn) btn.classList.remove("is-loading"); }
    enqueue(function () {
      return fetch(ADD_URL, { method: "POST", headers: { Accept: "application/json" }, body: fd })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          var note = $("[data-mcs-cd-error]", drawer);
          if (!res.ok) {
            var msg = (res.data && (res.data.description || res.data.message)) || "Could not add to cart.";
            if (note) { note.textContent = msg; note.hidden = false; }
          } else if (note) { note.hidden = true; }
          return (res.ok ? addGifts(fd) : Promise.resolve()).then(function () { return refresh(); }, function () { return refresh(); }).then(openDrawer);
        })
        // Always clear the lock. On a hard network failure, fall back to the cart page.
        .then(done, function () { done(); window.location.href = CART_URL; });
    });
  }

  /* ---- events ---- */
  function isProductAddForm(form) {
    if (!form || form.tagName !== "FORM") return false;
    var action = form.getAttribute("action") || "";
    return form.hasAttribute("data-product-form") || action.indexOf("/cart/add") > -1;
  }

  // Intercept add-to-cart in the capture phase so Empire's own handler never runs (no double add).
  document.addEventListener("submit", function (e) {
    var form = e.target;
    if (!isProductAddForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleAdd(form);
  }, true);

  document.addEventListener("click", function (e) {
    // open on header cart icon
    var cartBtn = e.target.closest(".site-header-cart--button, [data-mcs-open-cart]");
    if (cartBtn) { e.preventDefault(); refresh().then(openDrawer); return; }

    // close controls
    if (e.target.closest("[data-mcs-cd-close]")) { e.preventDefault(); closeDrawer(); return; }

    // qty + remove inside drawer
    if (!drawer) return;
    var itemEl = e.target.closest(".mcs-cd-item");
    if (!itemEl) return;
    var key = itemEl.getAttribute("data-key");
    var nEl = itemEl.querySelector(".mcs-cd-qty__n");
    var current = parseInt(nEl ? nEl.textContent : "1", 10) || 1;

    if (e.target.closest("[data-mcs-remove]")) {
      if (itemEl.getAttribute("data-busy") === "1") return; // ignore a second tap on the same remove
      itemEl.setAttribute("data-busy", "1");
      itemEl.classList.add("is-removing");
      enqueue(function () { return changeByKey(key, 0).then(render); });
      return;
    }

    var delta = e.target.closest("[data-mcs-qty-up]") ? 1 : (e.target.closest("[data-mcs-qty-dn]") ? -1 : 0);
    if (!delta) return;
    var target = Math.max(0, current + delta);
    // Optimistically reflect the new number AND price/subtotal immediately so a
    // rapid +,+,+ reads the running total and nothing waits on the network. The
    // queued change carries this exact target; render() reconciles on response.
    if (nEl) nEl.textContent = target;
    optimisticQty(itemEl, current, target);
    enqueue(function () { return changeByKey(key, target).then(render); });
  });

  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawer(); });

  /* ---- upsell (Section Rendering API: complementary -> related fallback) ---- */
  function initUpsell() {
    var mount = document.getElementById("mcs-upsell-mount");
    if (!mount) return;
    var pid = mount.getAttribute("data-product-id");
    if (!pid) return;
    var base = (window.Theme && window.Theme.routes && window.Theme.routes.product_recommendations_url) || "/recommendations/products";
    function load(intent) {
      var url = base + "?section_id=mcs-upsell&product_id=" + encodeURIComponent(pid) + "&intent=" + intent + "&limit=4";
      return fetch(url, { headers: { Accept: "text/html" } })
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement("div");
          tmp.innerHTML = html;
          return tmp.querySelector(".mcs-upsell") ? html : "";
        });
    }
    load("complementary").then(function (html) {
      if (html) { mount.innerHTML = html; return; }
      return load("related").then(function (h2) { if (h2) mount.innerHTML = h2; });
    }).catch(function () {});
  }

  /* ---- "+ Free Shipping" inline on the price (Empire re-renders the price
     container client-side, so inject via JS and keep it with an observer) ---- */
  function initFreeShip() {
    var pricing = document.querySelector('.product-pricing[data-mcs-free-ship="1"]');
    if (!pricing) return;
    function ensure() {
      var cur = pricing.querySelector(".price__current[data-price-container]") || pricing.querySelector(".price__current");
      if (!cur || cur.querySelector(".mcs-free-ship")) return;
      var span = document.createElement("span");
      span.className = "mcs-free-ship";
      span.textContent = "+ Free Shipping";
      cur.appendChild(span);
    }
    ensure();
    try {
      new MutationObserver(ensure).observe(pricing, { childList: true, subtree: true });
    } catch (e) {}
  }

  /* ---- Quick-features discount line: show the product's automatic discount %
     from window.MCS_DISCOUNTS (synced from Shopify), else keep the fallback ---- */
  function initDiscountLine() {
    var el = document.querySelector("[data-mcs-discount-line]");
    var wrap = document.querySelector(".qf-inline[data-mcs-vendor]");
    if (!el || !wrap || !window.MCS_DISCOUNTS) return;
    var d = window.MCS_DISCOUNTS;
    var vendor = wrap.getAttribute("data-mcs-vendor") || "";
    var pct = (d.vendors && d.vendors[vendor]) || d.all || 0;
    if (pct > 0) {
      el.textContent = "Extra " + pct + "% off, applied in cart";
    }
  }

  /* ---- Estimated delivery countdown (block markup is in
     snippets/mcs-estimated-delivery-block.liquid; settings come via data-attrs) ---- */
  function initEstDelivery() {
    var el = document.querySelector("[data-mcs-ed]");
    if (!el) return;
    var textEl = el.querySelector(".mcs-ed-blk__text");
    if (!textEl) return;
    var cutoffHour = parseInt(el.getAttribute("data-ed-cutoff"), 10); if (isNaN(cutoffHour)) cutoffHour = 17;
    var minDays = parseInt(el.getAttribute("data-ed-min"), 10) || 6;
    var maxDays = parseInt(el.getAttribute("data-ed-max"), 10) || 10;
    var maxCountdownHours = parseInt(el.getAttribute("data-ed-countdown"), 10) || 12;

    function estNow() {
      return new Date(new Date().toLocaleString("en-US", { timeZone: "America/New_York" }));
    }
    function addBusinessDays(start, n) {
      var r = new Date(start), added = 0;
      while (added < n) { r.setDate(r.getDate() + 1); var d = r.getDay(); if (d !== 0 && d !== 6) added++; }
      return r;
    }
    function fmt(d) { return d.toLocaleDateString("en-US", { month: "short", day: "numeric" }); }
    function update() {
      var now = estNow();
      var cutoff = new Date(now); cutoff.setHours(cutoffHour, 0, 0, 0);
      var isWeekend = now.getDay() === 0 || now.getDay() === 6;
      var before = now < cutoff;
      var diff = cutoff - now;
      var hrsLeft = diff / 3600000;
      var base = new Date(now);
      var range = "<strong>" + fmt(addBusinessDays(base, minDays)) + " - " + fmt(addBusinessDays(base, maxDays)) + "</strong>";
      if (!isWeekend && before && hrsLeft <= maxCountdownHours) {
        var h = Math.floor(diff / 3600000), m = Math.floor((diff % 3600000) / 60000);
        textEl.innerHTML = "Order within <strong>" + h + "h " + m + "m</strong> to get it by " + range;
      } else {
        textEl.innerHTML = "Order today to get it by " + range;
      }
    }
    update();
    setInterval(update, 60000);
  }

  function init() {
    drawer = document.getElementById("mcs-cart-drawer");
    initUpsell();
    /* initFreeShip() removed: the owner asked for the green "+ Free Shipping"
       next to the price to go. The function is left in place so it can be put
       back with one line if that changes. */
    initDiscountLine();
    initEstDelivery();
    if (!drawer) return;
    // hydrate count/markup from current cart without opening
    getCart().then(function (cart) {
      var countEl = $("[data-mcs-cd-count]", drawer);
      if (countEl) countEl.textContent = cart.item_count ? "(" + cart.item_count + ")" : "";
      // pre-render so first open is instant
      render(cart);
    }).catch(function () {});
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();

  // Returning via the browser back button restores this page from the bfcache
  // with whatever cart was last rendered (e.g. what you saw before going to
  // checkout). DOMContentLoaded does NOT re-fire on a bfcache restore, so
  // re-sync the drawer from the live cart whenever the page is shown from cache.
  window.addEventListener("pageshow", function (e) {
    if (e.persisted && document.getElementById("mcs-cart-drawer")) refresh();
  });

  // Small public handle so other PDP scripts (assets/mcs-bundle.js) can re-sync and open the
  // drawer after their own /cart/add.js fetch, instead of synthesising a document click that
  // every third-party click listener on the page also has to run.
  window.MCSCartDrawer = {
    refresh: refresh,
    open: openDrawer,
    close: closeDrawer,
    refreshAndOpen: function () { return refresh().then(openDrawer); }
  };
})();
